import * as React from "react"
import { Breadcrumbs } from "../sharedLayout/breadcrumbs"
import { getBreadcrumbsEventForm } from "./eventForm.state"
import { Event } from "../models/Events/Events"
import { EventPage } from "../cmsPage/cmsPageState"

type EventFormHeaderProps = {
  pageData: EventPage
  event: Event
}

export const EventFormHeader = (props: EventFormHeaderProps) => {
  const { pageData, event } = props
  return <header className="pageheader pageheader--text pageheader--cw">
    <div className="pageheader__inner">
      <div className="pageheader__content container--m gutter--m spacing--m">
        <Breadcrumbs links={getBreadcrumbsEventForm(pageData).links} />
        <h1 className="pageheader__title title--l">{event.name}</h1>
      </div>
    </div>
  </header>
}
